<script lang="ts">
  // A person's avatar + name, with an optional connection status — the shared way to
  // show "who acts here". Used by the Auto DMs sender picker, and reusable anywhere a
  // Skool account is shown with whether we can act as it. Wraps the shared Avatar.
  import Avatar from './Avatar.svelte';

  let {
    name = '',
    avatarUrl = null,
    size = 24,
    connected = null,
    subtle = false,
  }: {
    name?: string;
    avatarUrl?: string | null;
    size?: number;
    /** null hides the status; true/false shows a Connected / Not connected pill. */
    connected?: boolean | null;
    subtle?: boolean;
  } = $props();
</script>

<span class="inline-flex items-center gap-2 min-w-0">
  <Avatar src={avatarUrl} {name} {size} />
  <!-- The name is redacted; the Connected/Not-connected pill beside it is not — that
       is a state of OUR integration, not a fact about the person. -->
  <span class="redact truncate {subtle ? 'text-base-content/60' : ''}">{name}</span>
  {#if connected !== null}
    <span
      class="inline-flex items-center gap-1 text-xs whitespace-nowrap
             {connected ? 'text-success' : 'text-warning'}"
    >
      <span class="w-1.5 h-1.5 rounded-full {connected ? 'bg-success' : 'bg-warning'}"></span>
      {connected ? 'Connected' : 'Not connected'}
    </span>
  {/if}
</span>
